<template>
  <v-col width="100%" height="100%" class=" p-30 onboarding-content">
    <v-form
      class="form-profile"
      ref="formProfile"
      v-model="valid"
      lazy-validation
    >
      <div class="form-inputs-wrapper">
        <v-text-field
          dense
          v-model="name"
          label="Nombre de pila"
          :rules="rules"
          required
          class="capitalize"
          @change="name = $event"
          :disabled="getDisabledInputs('name')"
          :style="styles"
        ></v-text-field>
        <v-text-field
          dense
          v-model="email"
          label="Email"
          :rules="emailRules"
          @change="email = $event"
          :style="styles"
          :disabled="getDisabledInputs('email')"
        ></v-text-field>
        <vue-phone-number-input
          :translations="{
            countrySelectorLabel: null,
            countrySelectorError: 'Escoge un país',
            phoneNumberLabel: 'Número de teléfono',
            example: 'Ej.'
          }"
          v-model="phone"
          :border-radius="0"
          :default-country-code="'ES'"
          :preferred-countries="['ES']"
          show-code-on-list
          @change="phone = $event"
          :disabled="getDisabledInputs('phone')"
        />
        <div class="how-many-children" :style="styles">
          ¿Tienes hijos o los tendrás pronto?
        </div>
        <v-switch
          inset
          v-model="has_children"
          :label="has_children ? 'Sí' : 'No'"
          @change="has_children = $event"
          :disabled="getDisabledInputs('has_children')"
          :style="styles"
        ></v-switch>
        <div v-show="has_children">
          <v-dialog
            v-for="(itemField, index) in children_birthdate"
            v-model="itemField.show"
            ref="children_birthdate"
            :return-value.sync="itemField.value"
            :key="`childrenBirthdate${index}`"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <p v-show="index === 0" :style="styles">
                Indica la fecha de nacimiento de tus hijos
              </p>
              <v-text-field
                v-model="itemField.value"
                prepend-icon="mdi-calendar-month-outline"
                readonly
                :rules="rulesRequired"
                :label="
                  `Fecha de nacimiento de tu ${children_placeholder_texts[index]}`
                "
                @change="itemField.value = $event"
                :disabled="getDisabledInputs('children_birthdate')"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  v-show="index > 0"
                  @click="remove(index)"
                  slot="append"
                  color="red"
                  >mdi-minus</v-icon
                >
              </v-text-field>
            </template>
            <v-date-picker
              :active-picker.sync="itemField.activePicker"
              v-model="itemField.value"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="itemField.show = false"
                :style="styles"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.children_birthdate[index].save(itemField.value)"
                :style="styles"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
          <div
            class="d-flex align-center mb-10"
            v-if="childrenBirthdateLength"
            @click="add()"
          >
            <v-btn text icon>
              <v-icon size="16" color="primary">
                mdi-plus
              </v-icon>
            </v-btn>
            <span
              style="color:#1976d2; font-size:14px"
              :style="stylesAddOtheChild"
              >Añadir otro hijo</span
            >
          </div>
        </div>
      </div>
      <div class="form-buttons-wrapper">
        <v-btn
          :disabled="!valid"
          large
          block
          color="primary"
          class="rounded-lg"
          @click="validate"
        >
          Guardar
        </v-btn>
        <v-snackbar
          top
          v-model="snackbar"
          :vertical="vertical"
          color="success"
          timeout="5000"
        >
          {{ text }}
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </div>
    </v-form>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VuePhoneNumberInput from 'vue-phone-number-input'
import { convertEmToPixels } from '@/helper/helper'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { _ } from 'vue-underscore'
import { RegisterEvent } from '@/analytics'
// import { titleize } from '@/helper/index.js'

const profileFields = {
  name: null,
  surname: null,
  phone: null,
  email: null,
  has_children: true,
  children_birthdate: [
    {
      value: ''
    }
  ]
}

export default {
  name: 'EditProfile',
  created: function () {
    this.loading = true
    this.callProfileAction()
  },
  props: {
    source: Object
  },
  data: () => {
    let initialized = {
      modalBirthdate: false,
      activePicker: null,
      valid: true,
      loading: true,
      isSuccess: false,
      snackbar: false,
      text: 'Datos guardados con éxito',
      children_placeholder_texts: [
        'primer hijo',
        'segundo hijo',
        'tercer hijo',
        'cuarto hijo',
        'quinto hijo',
        'sexto hijo',
        'séptimo hijo',
        'octavo hijo'
      ],
      vertical: false,
      rules: [value => (value && value.length >= 3) || 'Min 3 characters'],
      emailRules: [v => /.+@.+\..+/.test(v) || 'E-mail debe ser válido'],
      rulesRequired: [v => !!v || 'Required']
    }
    for (const fieldKey in profileFields) {
      initialized[fieldKey] = profileFields[fieldKey]
    }
    return initialized
  },
  components: { VuePhoneNumberInput },
  watch: {
    modalBirthdate (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    children_birthdate: {
      handler (item) {
        item.activePicker = 'YEAR'
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['getProfileData']),
    childrenBirthdateLength: function () {
      return this.children_birthdate.length <= 7
    },
    styles () {
      const result = convertEmToPixels(16)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    },
    stylesAddOtheChild () {
      const result = convertEmToPixels(14)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    }
  },
  methods: {
    ...mapActions({
      profileAction: 'GET_PROFILE',
      saveBoarding: 'ONBOARDING',
      addChangeToQueue: 'ADD_TO_QUEUE'
    }),
    callProfileAction () {
      this.profileAction().then(profile => {
        profile.children_birthdate = _.isEmpty(profile.children_birthdate)
          ? ['']
          : profile.children_birthdate
        for (const field in profile) {
          this[field] = _.isArray(profileFields[field])
            ? (profile[field] || []).map(val => ({ value: val }))
            : profile[field]
        }
        this.loading = false
      })
    },
    validate () {
      let dataToSend = {}
      for (const fieldKey in profileFields) {
        dataToSend[fieldKey] = _.isArray(this[fieldKey])
          ? this[fieldKey].map(({ value }) => value)
          : this[fieldKey]
      }
      this.$refs.formProfile.validate() &&
        this.saveBoarding(dataToSend).then(() => {
          RegisterEvent('chi_save_profile', {
            target: this.$store.getters.firebaseUUID(),
            target_type: 'user_id'
          })
          this.isSuccess = true
          this.snackbar = true
          this.addChangeToQueue({
            currentScreen: 'users',
            fieldsName: [
              'name',
              'surname',
              'email',
              'phone',
              'has_children',
              'children_birthdate',
              'disabled_fields'
            ]
          })
        })
    },
    add () {
      let value = {
        value: '',
        show: true
      }
      this.children_birthdate.push(value)
    },
    remove (index) {
      this.children_birthdate.splice(index, 1)
    },
    getDisabledInputs (name) {
      return _.indexOf(this.getProfileData.disabled_fields, name) > 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/EditProfile.vue